import "./styles.scss";
import { InsuranceProviders } from "../../js/insurance-providers";

new InsuranceProviders();
